import * as React from "react";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { Navigator } from "../../../../../../Shared/Wizards/Entities/Navigator";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { Urls } from "../../../../../Urls";
import { DrawdownReview } from "../../../Common/Review/Component/DrawdownReview";
import { Declarations } from "./Declarations";
import { IncomePaymentReview } from "../../../Common/Review/Component/IncomePaymentReview";
import {
    hasEnhancedPensionProtection,
    showChooseAssetstoSell,
} from "../../../Common/SIPP/DrawdownDetails/Helper/DrawdownDetailHelper";
import { ChooseAssetsToSellFor } from "../../../Common/SIPP/DrawdownDetails/Resource/Contents";
import { PensionContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { PensionOption } from "../../../../../../../Wrap/Constants/Enums/Apply/PensionOption";

interface IReviewProps extends IProcessComponentProps {
    type: SubAccountType;
    data: PensionContributionModel;
    hasCashIsa?: boolean;
}

interface IReviewState {}

export class Review extends ProcessComponent<IReviewProps, IReviewState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private getProps = () => {
        const { onChange, data, showErrorMsgPopUp, isReview } = this.props;
        return {
            data: data,
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data),
            isReview: isReview,
        };
    };
    private showAssetsToSell = () => {
        return showChooseAssetstoSell(this.props.data?.Contribution.DrawdownModel, ChooseAssetsToSellFor.Drawdown);
    };
    public render(): JSX.Element {
        const { data } = this.props;

        return (
            <>
                <h2>Review</h2>
                <DrawdownReview
                    showDrawdownPriceLock={true}
                    showAssetsToSell={this.showAssetsToSell()}
                    colNum={3}
                    process={ProcessType.TakePensionBenefits}
                    data={this.props.data.Contribution}
                    modelData={this.props.data}
                    isImmediateLumpSum={false} // need integration with itfc
                    onEditAction={() =>
                        Navigator.navigateToAndPreserveQueryParameters(Urls.get().PensionBenefitsDetails)
                    }
                    hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.Contribution)}
                />
                {this.props.data?.Contribution?.DrawdownModel?.PensionOption != PensionOption.UFPLS && (
                    <IncomePaymentReview
                        colNum={3}
                        process={ProcessType.TakePensionBenefits}
                        data={this.props.data.Contribution}
                        model={this.props.data}
                        onEditAction={() =>
                            Navigator.navigateToAndPreserveQueryParameters(
                                Urls.get().PensionBenefitsIncomePaymentDetails
                            )
                        }
                        isITFC={false}
                    />
                )}
                <Declarations {...this.getProps()}></Declarations>
            </>
        );
    }
}
